import { CONST } from '../_config';
import { authHeader } from '../_helpers';
import CryptoJS from 'crypto-js';

export const questionsService = {
    logout,
    saveAnswers,
    saveInsightAnswers,
    getQuestionList,
    getLanguageLabel,
    getSurveyTemplateByCode,
    getInsightSurveyCode,
    getEmployeeStatus,
    getSurveyDetailsBySurveyCode,
    getRespondantName,

    getAssessmentSurveyTemplateByCode,
    getAssessmenrEmployeeDetails,
    getAssessmentQuestionList,
    saveAssessmentAnswers,
    assessmentLogout,

    getAssessmentReport,
    getAssessmentStatus,
    getTranslateElementAll,
    getSurveyDesignByCode,
    getEMPWiseDemographicValue,
    saveSurveyConsent,

    getParameterCategory,

    //leadership api
    getLeadershipReportScore_USER,
    getLeadershipParaCategory_USER,
    getLeadershipTextDetails_USER,
    getParameterLibraryNameList,

    saveCheatLogs,
    quickSaveAnswers,
    getLastSaveQuestion

};
function logout() {
    localStorage.removeItem('adminuser');
    // window.location.href = "#/login";
    // window.location.reload();

}
function assessmentLogout() {
    localStorage.removeItem('adminuser');
    window.location.href = "#/insight/signin";
    window.location.reload();
}
function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        if (data.error) {
            if (data.code === 3) {
                logout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}


function handleResponseV3(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                assessmentLogout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        if (data.error) {
            if (data.code === 3) {
                assessmentLogout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}


function getParameterCategory(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getParameterCategory`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getParameterCategoryData: data.data
            }
            return questionObj


        });
}



function getLeadershipReportScore_USER(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getLeadershipReportScore_USER`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getLeadershipReportScore_USERData: data.data
            }
            return questionObj


        });
}

function getLeadershipParaCategory_USER(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getLeadershipParaCategory_USER`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getLeadershipParaCategory_USERData: data.data
            }
            return questionObj


        });
}


function getLeadershipTextDetails_USER(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getLeadershipTextDetails_USER`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getLeadershipTextDetails_USERData: data.data
            }
            return questionObj


        });
}


function getParameterLibraryNameList(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getParameterLibraryNameList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getParameterLibraryNameListData: data.data
            }
            return questionObj


        });
}



function getQuestionList(value, Template) {
    let header = new Headers({
        'Content-Type': 'application/json'
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)
    }

    function shuffle(array) {
        let currentIndex = array.length, randomIndex;
        while (currentIndex != 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }


    if (Template === "v4") {
        return fetch(CONST.BACKEND_SURVEY_URL + `/getQuestionList`, requestOptions)
            .then(handleResponse)
            .then(data => {

                let SortedQuestionList = []
                let GroupQuestionOnlyList = []

                if (data.data.questionList && data.data.questionList.length > 0) {
                    let DataQuestionList = data.data.questionList;
                    console.log('data.data', data.data)

                    if (data && data.data && data.data.survey && data.data.survey.isRandomize) {
                        console.log('isRandomize!')



                        let ShuffledQuestionList = shuffle(DataQuestionList);
                        if (ShuffledQuestionList && ShuffledQuestionList.length > 0) {
                            ShuffledQuestionList.forEach((element, indexS) => {
                                element["rank"] = indexS;
                                SortedQuestionList.push(element)
                            })
                        }



                    } else {
                        SortedQuestionList = DataQuestionList.sort((a, b) => a.rank - b.rank);
                    }
                    // console.log('DataQuestionList : ',DataQuestionList)
                    // console.log('SortedQuestionList : ',SortedQuestionList)

                    GroupQuestionOnlyList = DataQuestionList.filter(prev => prev.parentId === null);

                }

                var QuesAns = [];
                // console.log("data data: ",data)

                let QuestionMain = [];
                let MatrixQuestion = [];
                let GroupQuestion = [];

                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.forEach((ques) => {
                        if (ques.templateId === 13) {
                            if (ques.parentId) {
                                MatrixQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push({
                                    ...ques,
                                    SubQuestionList: []
                                });
                            }
                        }
                        else if (ques.templateId === 14) {

                            // QuestionMain.push({
                            //     ...ques,
                            //     SubQuestionList:[]
                            // });

                            QuestionMain.push(ques);

                        }
                        else if (ques.templateId !== 13 && ques.templateId !== 14) {


                            if (ques.parentId) {
                                GroupQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push(ques);
                            }
                        }
                        else {


                            QuestionMain.push(ques);
                        }

                    });
                }



                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.map((quesData, quesDataIndex) => {


                        if (quesData.templateId === 2 || quesData.templateId === 21 || quesData.templateId === 22 || quesData.templateId === 23) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                feedback: "",
                                multiAnswer: [],
                                milliseconds: 0,
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId
                            });
                            return QuesAns;
                        }
                        else if (quesData.templateId === 4 || quesData.templateId === 3) {
                            QuesAns.push({
                                questionId: quesData.id,
                                feedback: "",
                                answer: "",
                                answer1: "",
                                answer2: "",
                                milliseconds: 0,
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else if (quesData.templateId === 13) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                feedback: "",
                                milliseconds: 0,
                                multiAnswer: [],
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else {
                            return QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                feedback: "",
                                milliseconds: 0,
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                questionTemplateId: quesData.templateId,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            })
                        }

                    })
                }



                if (MatrixQuestion && MatrixQuestion.length > 0) {
                    MatrixQuestion.forEach((ques) => {
                        let getIndex = QuestionMain.findIndex(prev => prev.id === ques.parentId);
                        if (getIndex !== -1) {
                            QuestionMain[getIndex]["SubQuestionList"].push(ques);
                        }

                    });
                }

                let QuestionMainFinal = [];

                //console.log("x Template2===========>",Template,GroupQuestion)

                if (Template === "v4") {
                    if (QuestionMain && QuestionMain.length > 0) {
                        QuestionMain.forEach((Mainques) => {

                            if (Mainques.templateId !== 14) {
                                QuestionMainFinal.push(Mainques);
                            }

                            // console.log("x Mainques===========>",Mainques)
                            //console.log("x GroupQuestion===========>",GroupQuestion)

                            if (GroupQuestion && GroupQuestion.length > 0) {
                                GroupQuestion.forEach((ques) => {
                                    if (ques.parentId === Mainques.id) {
                                        let tempData = {
                                            ...ques,
                                            QuesMain: Mainques
                                        }
                                        QuestionMainFinal.push(tempData);
                                    }
                                });
                            }

                        });
                    }
                }
                else {
                    // if(GroupQuestion && GroupQuestion.length>0){
                    //     GroupQuestion.forEach((ques)=>{
                    //         let getIndex = QuestionMain.findIndex(prev=>prev.id===ques.parentId);
                    //         if(getIndex!==-1){
                    //             QuestionMain[getIndex]["SubQuestionList"].push(ques);
                    //         }
                    //     });
                    // }
                    // QuestionMainFinal = QuestionMain;
                }




                // console.log('{{{{{{{----------------> QuestionMainFinal',QuestionMainFinal)

                // let cryptedText = CryptoJS.AES.encrypt(JSON.stringify(question), "secretkey123").toString();
                // localStorage.setItem('tempQuestion', JSON.stringify(cryptedText));


                // let storedAnswers = JSON.parse(localStorage.getItem('myAnswers'));


                let storedAnswers = "";

                try {

                    let localData = localStorage.getItem('myAnswers');
                    console.log('{{{{{{{1----------------> localData', localData)

                    let cryptedText = localData ? JSON.parse(localData) : "";
                    console.log('{{{{{{{2----------------> cryptedText', cryptedText)
                    let bytes = cryptedText ? CryptoJS.AES.decrypt(cryptedText, "secretkey123") : "";
                    console.log('{{{{{{{3----------------> bytes', bytes)

                    storedAnswers = bytes ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) : "";
                    console.log('{{{{{{{4----------------> storedAnswers', storedAnswers)

                } catch (error) {
                    storedAnswers = ""
                }


                // console.log('{{{{{{{----------------> storedAnswers', storedAnswers)
                console.log('{{{{{{{----------------> value.code', value.code)

                let newStoredQuestions = []
                if (storedAnswers && storedAnswers.length > 0) {
                    newStoredQuestions = storedAnswers && storedAnswers.length > 0 ? storedAnswers : [];
                } else {
                    // localStorage.removeItem('myAnswers');
                }
                console.log('{{{{{{{-------------x1---> newStoredQuestions', newStoredQuestions)
                console.log('{{{{{{{-------------x2---> QuesAns', QuesAns)


                // console.log('----------{{{{{{{----------------> storedAnswers',storedAnswers)
                //console.log('----------{{{{{{{----------------> QuesAns',QuesAns)

                let NewAnswerList = []
                if (newStoredQuestions && newStoredQuestions.length > 0 && QuesAns && QuesAns.length > 0 &&
                    (newStoredQuestions.length === QuesAns.length)) {
                    newStoredQuestions.forEach((item) => {

                        let tempData = {
                            ...item
                        }
                        let getIndex = QuesAns.findIndex(prev => prev.questionId === item.questionId);
                        if (getIndex !== -1) {


                            // if(item.template===13){
                            //     tempData['multiAnswer'] =  QuesAns && QuesAns[getIndex] && QuesAns[getIndex].multiAnswer && QuesAns[getIndex].multiAnswer.length>0?QuesAns[getIndex].multiAnswer:[];
                            // }


                            tempData['isMandatory'] = QuesAns && QuesAns[getIndex] && QuesAns[getIndex].isMandatory ? true : false;
                        }
                        NewAnswerList.push(tempData);
                    });
                }
                else {
                    NewAnswerList = QuesAns
                }


                console.log('{{{{{{{-------------x3---> NewAnswerList', NewAnswerList)

                //console.log('----------{{{{{{{----------------> QuesAns',QuesAns)

                //console.log('----------{{{{{{{----------------> GroupQuestionOnlyList',GroupQuestionOnlyList)

                let questionObj = {
                    questionsList: QuestionMainFinal,
                    answersList: NewAnswerList,
                    surveyScreenData: data.data.survey,
                    surveyStatus: data.data.status,
                    langList: data.data.langList,
                    GroupQuestionOnlyList: GroupQuestionOnlyList
                }
                // console.log("questionObj  ", questionObj);

                return questionObj;
            });
    }
    else {
        return fetch(CONST.BACKEND_SURVEY_URL + `/getQuestionList`, requestOptions)
            .then(handleResponse)
            .then(data => {

                let SortedQuestionList = []
                if (data.data.questionList && data.data.questionList.length > 0) {
                    SortedQuestionList = data.data.questionList.sort((a, b) => a.rank - b.rank);
                    // console.log('questionsList V : ',SortedQuestionList)
                }

                var QuesAns = [];
                // console.log("data data: ",data)

                let QuestionMain = [];
                let MatrixQuestion = [];
                let GroupQuestion = [];

                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.forEach((ques) => {
                        if (ques.templateId === 13) {
                            if (ques.parentId) {
                                MatrixQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push({
                                    ...ques,
                                    SubQuestionList: []
                                });
                            }
                        }
                        else if (ques.templateId === 14) {

                            QuestionMain.push({
                                ...ques,
                                SubQuestionList: []
                            });
                        }
                        else if (ques.templateId !== 13 && ques.templateId !== 14) {


                            if (ques.parentId) {
                                GroupQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push(ques);
                            }
                        }
                        else {


                            QuestionMain.push(ques);
                        }

                    });
                }



                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.map((quesData, quesDataIndex) => {


                        if (quesData.templateId === 2 || quesData.templateId === 21 || quesData.templateId === 22 || quesData.templateId === 23) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                multiAnswer: [],
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId
                            });
                            return QuesAns;
                        }
                        else if (quesData.templateId === 4) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                answer1: "",
                                answer2: "",
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else if (quesData.templateId === 13) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                multiAnswer: [],
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else {
                            return QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId


                            })
                        }

                    })
                }



                if (MatrixQuestion && MatrixQuestion.length > 0) {
                    MatrixQuestion.forEach((ques) => {
                        let getIndex = QuestionMain.findIndex(prev => prev.id === ques.parentId);
                        if (getIndex !== -1) {
                            QuestionMain[getIndex]["SubQuestionList"].push(ques);
                        }

                    });
                }


                if (GroupQuestion && GroupQuestion.length > 0) {
                    GroupQuestion.forEach((ques) => {
                        let getIndex = QuestionMain.findIndex(prev => prev.id === ques.parentId);
                        if (getIndex !== -1) {
                            QuestionMain[getIndex]["SubQuestionList"].push(ques);
                        }
                    });
                }



                //console.log('{{{{{{{----------------> QuestionMain',QuestionMain)



                let questionObj = {
                    questionsList: QuestionMain,
                    answersList: QuesAns,
                    surveyScreenData: data.data.survey,
                    surveyStatus: data.data.status,
                    langList: data.data.langList
                }
                // console.log("questionObj  ", questionObj);

                return questionObj;
            });
    }


}


function getAssessmentQuestionList(data, Template) {
    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }

    function shuffle(array) {
        let currentIndex = array.length, randomIndex;
        while (currentIndex != 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }


    if (Template === "v4") {
        return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentQuestionList`, requestOptions)
            .then(handleResponseV3)
            .then(data => {

                let SortedQuestionList = []
                let GroupQuestionOnlyList = []

                if (data.data.questionList && data.data.questionList.length > 0) {
                    let DataQuestionList = data.data.questionList;
                    console.log('data.data', data.data)

                    if (data && data.data && data.data.survey && data.data.survey.isRandomize) {
                        console.log('isRandomize!')



                        let ShuffledQuestionList = shuffle(DataQuestionList);
                        if (ShuffledQuestionList && ShuffledQuestionList.length > 0) {
                            ShuffledQuestionList.forEach((element, indexS) => {
                                element["rank"] = indexS;
                                SortedQuestionList.push(element)
                            })
                        }



                    } else {
                        SortedQuestionList = DataQuestionList.sort((a, b) => a.rank - b.rank);
                    }
                    // console.log('DataQuestionList : ',DataQuestionList)
                    // console.log('SortedQuestionList : ',SortedQuestionList)

                    GroupQuestionOnlyList = DataQuestionList.filter(prev => prev.parentId === null);

                }

                var QuesAns = [];
                // console.log("data data: ",data)

                let QuestionMain = [];
                let MatrixQuestion = [];
                let GroupQuestion = [];

                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.forEach((ques) => {
                        if (ques.templateId === 13) {
                            if (ques.parentId) {
                                MatrixQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push({
                                    ...ques,
                                    SubQuestionList: []
                                });
                            }
                        }
                        else if (ques.templateId === 14) {

                            // QuestionMain.push({
                            //     ...ques,
                            //     SubQuestionList:[]
                            // });

                            QuestionMain.push(ques);

                        }
                        else if (ques.templateId !== 13 && ques.templateId !== 14) {


                            if (ques.parentId) {
                                GroupQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push(ques);
                            }
                        }
                        else {


                            QuestionMain.push(ques);
                        }

                    });
                }



                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.map((quesData, quesDataIndex) => {


                        if (quesData.templateId === 2) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                multiAnswer: [],
                                milliseconds: 0,
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }
                        else if (quesData.templateId === 4) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                answer1: "",
                                answer2: "",
                                milliseconds: 0,
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else if (quesData.templateId === 13) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                milliseconds: 0,
                                multiAnswer: [],
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else {
                            return QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                feedback: "",
                                milliseconds: 0,
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                questionTemplateId: quesData.templateId,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            })
                        }

                    })
                }



                if (MatrixQuestion && MatrixQuestion.length > 0) {
                    MatrixQuestion.forEach((ques) => {
                        let getIndex = QuestionMain.findIndex(prev => prev.id === ques.parentId);
                        if (getIndex !== -1) {
                            QuestionMain[getIndex]["SubQuestionList"].push(ques);
                        }

                    });
                }

                let QuestionMainFinal = [];

                //console.log("x Template2===========>",Template,GroupQuestion)

                if (Template === "v4") {
                    if (QuestionMain && QuestionMain.length > 0) {
                        QuestionMain.forEach((Mainques) => {

                            if (Mainques.templateId !== 14) {
                                QuestionMainFinal.push(Mainques);
                            }

                            // console.log("x Mainques===========>",Mainques)
                            //console.log("x GroupQuestion===========>",GroupQuestion)

                            if (GroupQuestion && GroupQuestion.length > 0) {
                                GroupQuestion.forEach((ques) => {
                                    if (ques.parentId === Mainques.id) {
                                        let tempData = {
                                            ...ques,
                                            QuesMain: Mainques
                                        }
                                        QuestionMainFinal.push(tempData);
                                    }
                                });
                            }

                        });
                    }
                }
                else {
                    // if(GroupQuestion && GroupQuestion.length>0){
                    //     GroupQuestion.forEach((ques)=>{
                    //         let getIndex = QuestionMain.findIndex(prev=>prev.id===ques.parentId);
                    //         if(getIndex!==-1){
                    //             QuestionMain[getIndex]["SubQuestionList"].push(ques);
                    //         }
                    //     });
                    // }
                    // QuestionMainFinal = QuestionMain;
                }




                // console.log('{{{{{{{----------------> QuestionMainFinal',QuestionMainFinal)

                // let cryptedText = CryptoJS.AES.encrypt(JSON.stringify(question), "secretkey123").toString();
                // localStorage.setItem('tempQuestion', JSON.stringify(cryptedText));


                // let storedAnswers = JSON.parse(localStorage.getItem('myAnswers'));


                let storedAnswers = "";

                try {

                    let localData = localStorage.getItem('myAnswers');
                    let cryptedText = localData ? JSON.parse(localData) : "";
                    let bytes = cryptedText ? CryptoJS.AES.decrypt(cryptedText, "secretkey123") : "";

                    storedAnswers = bytes ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) : "";
                } catch (error) {
                    storedAnswers = ""
                }




                // console.log('----------{{{{{{{----------------> storedAnswers',storedAnswers)
                //console.log('----------{{{{{{{----------------> QuesAns',QuesAns)

                let NewAnswerList = []
                if (storedAnswers && storedAnswers.length > 0 && QuesAns && QuesAns.length > 0 && (storedAnswers.length === QuesAns.length)) {
                    storedAnswers.forEach((item) => {

                        let tempData = {
                            ...item
                        }
                        let getIndex = QuesAns.findIndex(prev => prev.questionId === item.questionId);
                        if (getIndex !== -1) {


                            // if(item.template===13){
                            //     tempData['multiAnswer'] =  QuesAns && QuesAns[getIndex] && QuesAns[getIndex].multiAnswer && QuesAns[getIndex].multiAnswer.length>0?QuesAns[getIndex].multiAnswer:[];
                            // }


                            tempData['isMandatory'] = QuesAns && QuesAns[getIndex] && QuesAns[getIndex].isMandatory ? true : false;
                        }
                        NewAnswerList.push(tempData);
                    });
                }
                else {
                    NewAnswerList = QuesAns
                }

                //console.log('----------{{{{{{{----------------> QuesAns',QuesAns)

                //console.log('----------{{{{{{{----------------> GroupQuestionOnlyList',GroupQuestionOnlyList)

                let questionObj = {
                    questionsList: QuestionMainFinal,
                    answersList: NewAnswerList,
                    surveyScreenData: data.data.survey,
                    surveyStatus: data.data.status,
                    langList: data.data.langList,
                    GroupQuestionOnlyList: GroupQuestionOnlyList
                }
                // console.log("questionObj  ", questionObj);

                return questionObj;
            });
    }
    else {
        return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentQuestionList`, requestOptions)
            .then(handleResponseV3)
            .then(data => {

                let SortedQuestionList = []
                if (data.data.questionList && data.data.questionList.length > 0) {
                    SortedQuestionList = data.data.questionList.sort((a, b) => a.rank - b.rank);
                    // console.log('questionsList V : ',SortedQuestionList)
                }

                var QuesAns = [];
                // console.log("data data: ",data)

                let QuestionMain = [];
                let MatrixQuestion = [];
                let GroupQuestion = [];

                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.forEach((ques) => {
                        if (ques.templateId === 13) {
                            if (ques.parentId) {
                                MatrixQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push({
                                    ...ques,
                                    SubQuestionList: []
                                });
                            }
                        }
                        else if (ques.templateId === 14) {

                            QuestionMain.push({
                                ...ques,
                                SubQuestionList: []
                            });
                        }
                        else if (ques.templateId !== 13 && ques.templateId !== 14) {


                            if (ques.parentId) {
                                GroupQuestion.push(ques);
                            }
                            else {
                                QuestionMain.push(ques);
                            }
                        }
                        else {


                            QuestionMain.push(ques);
                        }

                    });
                }



                if (SortedQuestionList && SortedQuestionList.length > 0) {
                    SortedQuestionList.map((quesData, quesDataIndex) => {


                        if (quesData.templateId === 2) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                multiAnswer: [],
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }
                        else if (quesData.templateId === 4) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                answer1: "",
                                answer2: "",
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else if (quesData.templateId === 13) {
                            QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                multiAnswer: [],
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId

                            });
                            return QuesAns;
                        }

                        else {
                            return QuesAns.push({
                                questionId: quesData.id,
                                answer: "",
                                questionOptionId: "",
                                isMandatory: quesData.isMandatory,
                                parentId: quesData.parentId,
                                template: quesData.templateId


                            })
                        }

                    })
                }



                if (MatrixQuestion && MatrixQuestion.length > 0) {
                    MatrixQuestion.forEach((ques) => {
                        let getIndex = QuestionMain.findIndex(prev => prev.id === ques.parentId);
                        if (getIndex !== -1) {
                            QuestionMain[getIndex]["SubQuestionList"].push(ques);
                        }

                    });
                }


                if (GroupQuestion && GroupQuestion.length > 0) {
                    GroupQuestion.forEach((ques) => {
                        let getIndex = QuestionMain.findIndex(prev => prev.id === ques.parentId);
                        if (getIndex !== -1) {
                            QuestionMain[getIndex]["SubQuestionList"].push(ques);
                        }
                    });
                }



                //console.log('{{{{{{{----------------> QuestionMain',QuestionMain)



                let questionObj = {
                    questionsList: QuestionMain,
                    answersList: QuesAns,
                    surveyScreenData: data.data.survey,
                    surveyStatus: data.data.status,
                    langList: data.data.langList
                }
                // console.log("questionObj  ", questionObj);

                return questionObj;
            });
    }


}

function saveAnswers(data) {

    // console.log("---------- SAVE ANSWERS ----------------")
    // console.log(data)

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/saveAnswers`, requestOptions)
        .then(handleResponse)
        .then(data => {
            localStorage.removeItem('myAnswers');
            // return data.data;
            let questionObj = {}
            return questionObj


        });
}

function saveInsightAnswers(data) {

    // console.log("---------- SAVE ANSWERS ----------------")
    // console.log(data)

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveInsightAnswers`, requestOptions)
        .then(handleResponse)
        .then(data => {
            localStorage.removeItem('myAnswers');
            // return data.data;
            let questionObj = {}
            return questionObj


        });
}

function quickSaveAnswers(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/quickSaveAnswers`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                quickSaveAnswersData: data.data
            }
            return questionObj


        });
}

function getLastSaveQuestion(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getLastSaveQuestion`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getLastSaveQuestionData: data.data
            }
            return questionObj
        });
}



function saveCheatLogs(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveCheatLogs`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                saveCheatLogsData: data.data
            }
            return questionObj


        });
}
function getAssessmenrEmployeeDetails(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmenrEmployeeDetails`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getAssessmenrEmployeeDetailsData: data.data
            }
            return questionObj


        });
}





function saveAssessmentAnswers(data) {

    // console.log("---------- SAVE ANSWERS ----------------")
    // console.log(data)

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/saveAssessmentAnswers`, requestOptions)
        .then(handleResponseV3)
        .then(data => {
            localStorage.removeItem('myAnswers');
            // return data.data;
            let questionObj = {}
            return questionObj


        });
}

function getLanguageLabel(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getLanguageLabel`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getLanguageLabelData: data.data
            }
            return questionObj;
        });
}

function getInsightSurveyCode(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightSurveyCode`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getInsightSurveyCodeData: data.data
            }
            return questionObj;
        });
}

function getSurveyTemplateByCode(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getSurveyTemplateByCode`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getSurveyTemplateByCodeData: data.data
            }
            return questionObj;
        });
}

function getAssessmentSurveyTemplateByCode(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentSurveyTemplateByCode`, requestOptions)
        .then(handleResponseV3)
        .then(data => {
            let questionObj = {
                getSurveyTemplateByCodeData: data.data
            }
            return questionObj;
        });
}


function getSurveyDetailsBySurveyCode(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getSurveyDetailsBySurveyCode`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getSurveyDetailsBySurveyCodeData: data.data
            }
            return questionObj;
        });
}



function getEmployeeStatus(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getEmpSurveyCode`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getEmployeeStatusData: data.data
            }
            return questionObj;
        });
}



function getRespondantName(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getRespondantName`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getRespondantNameData: data.data
            }
            return questionObj;
        });
}


function getAssessmentReport(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentReport`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getAssessmentReportData: data.data
            }
            return questionObj;
        });
}

function getAssessmentStatus(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentStatus`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getAssessmentStatusData: data.data
            }
            return questionObj;
        });
}


function getTranslateElementAll(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getTranslateElementAll`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getTranslateElementAllData: data.data
            }
            return questionObj;
        });
}


function getSurveyDesignByCode(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getSurveyDesignByCode`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getSurveyDesignByCodeData: data.data
            }
            return questionObj;
        });
}


function saveSurveyConsent(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/saveSurveyConsent`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                saveSurveyConsentData: data.data
            }
            return questionObj;
        });
}

function getEMPWiseDemographicValue(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getEMPWiseDemographicValue`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                getEMPWiseDemographicValueData: data.data
            }
            return questionObj;
        });
}




